import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast"; 
import logo from "../components/icon.png"; 

function Login({ setIsAuth }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      
      // ✅ Login Success
      setIsAuth(true); 
      sessionStorage.setItem("isAuth", "true"); 
      toast.success("Welcome back! 🚀");
      navigate("/"); 
    } catch (err) {
      // ❌ Login Failed
      console.error(err);
      toast.error("Invalid Email or Password");
    }
    setLoading(false); 
  };

  return (
    <div style={containerStyle}>
      {/* BACKGROUND SHAPES */}
      <div style={circleOne}></div>
      <div style={circleTwo}></div>

      {/* LOGIN CARD */}
      <div style={cardStyle}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
            
            {/* 🔥 IMAGE LOGO SECTION */}
            <div style={logoContainer}>
                <img src={logo} alt="LMS Logo" style={logoImage} />
            </div>

            <h2 style={{ margin: "15px 0 5px 0", color: "#2c3e50", fontFamily: "'Segoe UI', sans-serif" }}>LMS Admin</h2>
            <p style={{ margin: 0, color: "#7f8c8d", fontSize: "14px" }}>Sign in to manage your empire</p>
        </div>

        <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          
          {/* Email Input */}
          <div style={{position: "relative"}}>
            <label style={labelStyle}>Email Address</label>
            <input 
              type="email" 
              placeholder="admin@company.com" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              style={inputStyle} 
              required 
            />
          </div>

          {/* Password Input */}
          <div style={{position: "relative"}}>
            <label style={labelStyle}>Password</label>
            <input 
              type={showPass ? "text" : "password"} 
              placeholder="••••••••" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              style={inputStyle} 
              required 
            />
            <span 
                onClick={() => setShowPass(!showPass)} 
                style={togglePassStyle}
            >
                {showPass ? "Hide" : "Show"}
            </span>
          </div>

          {/* Login Button */}
          <button 
            type="submit" 
            style={{...btnStyle, opacity: loading ? 0.7 : 1, cursor: loading ? "not-allowed" : "pointer"}}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Login to Dashboard"}
          </button>

        </form>

        {/* Footer */}
        <div style={{ marginTop: "25px", textAlign: "center", fontSize: "12px", color: "#95a5a6" }}>
            <p>Protected by Firebase Security</p>
            <p>© 2025 LMS System v2.0</p>
        </div>
      </div>
    </div>
  );
}

// ================= STYLES =================

const containerStyle = {
  height: "100vh",
  width: "100vw",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)", 
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Segoe UI', sans-serif"
};

const cardStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.95)", 
  padding: "40px",
  borderRadius: "15px",
  boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
  width: "380px",
  zIndex: 10,
  backdropFilter: "blur(10px)"
};

// 🔥 UPDATED LOGO STYLES
const logoContainer = {
    background: "#f0f4f8",
    width: "80px",       // Thoda bada kiya
    height: "80px",      // Thoda bada kiya
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    padding: "5px"       // Thoda padding taaki image kinare se na chipke
};

const logoImage = {
    width: "100%",       // Container ke hisaab se fit hoga
    height: "100%",
    objectFit: "contain", // Image katega nahi
    borderRadius: "50%"   // Agar image square hai to round ho jayegi
};

const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#34495e"
};

const inputStyle = {
  width: "100%",
  padding: "12px 15px",
  borderRadius: "8px",
  border: "1px solid #dcdde1",
  fontSize: "15px",
  boxSizing: "border-box",
  outline: "none",
  transition: "0.3s",
  backgroundColor: "#f9f9f9"
};

const togglePassStyle = {
    position: "absolute",
    right: "12px",
    top: "32px",
    fontSize: "12px",
    color: "#2980b9",
    cursor: "pointer",
    fontWeight: "bold"
};

const btnStyle = {
  width: "100%",
  padding: "14px",
  backgroundColor: "#2c3e50", 
  color: "white",
  border: "none",
  borderRadius: "8px",
  fontSize: "16px",
  fontWeight: "bold",
  marginTop: "10px",
  boxShadow: "0 4px 15px rgba(44, 62, 80, 0.3)",
  transition: "0.2s"
};

// Background Decorative Circles
const circleOne = {
    position: "absolute",
    top: "-50px",
    left: "-50px",
    width: "200px",
    height: "200px",
    background: "rgba(255,255,255,0.1)",
    borderRadius: "50%"
};

const circleTwo = {
    position: "absolute",
    bottom: "-80px",
    right: "-80px",
    width: "300px",
    height: "300px",
    background: "rgba(255,255,255,0.1)",
    borderRadius: "50%"
};

export default Login;